<!-- Data Visualization Chart Component Template -->
<div class="data-visualization-container">
  <!-- Data selection chips -->
  <div *ngIf="!loadingSignal() && hasDataSignal()" class="graph-header">
    <div class="chips-container">
      <div *ngFor="let chip of availableChips()" class="chip" [ngStyle]="getChipStyle">
        <span [style.backgroundColor]="chip.color"></span>
        {{
          chip.label === 'Capacity'
            ? ('COM.TABS.CLEARED.CLEARED_CAPACITY' | translate)
            : chip.label === 'Demand'
              ? ('COM.TABS.CLEARED.CLEARED_DEMAND' | translate)
              : chip.label
        }}
        <b>{{ chip.unit }}</b>
      </div>
    </div>

    <div class="date-container">
      <!-- <button (click)="previousDay()" mat-icon-button class="time-container_increament" [disabled]="isPreviousDayDisabled()">
        <dr-customer-offers-ui-icons name="chevron_left" size="extra-small"></dr-customer-offers-ui-icons>
      </button> -->
      <span class="date-container--day">{{ formattedCurrentDate }}</span>
      <div class="relative-position">
        <button
          *ngIf="isBulkImportAllowed()"
          data-cy="clear-tab-more-options"
          mat-icon-button
          (click)="toggleDownloadUploadOptions($event)"
          class="more-options-btn"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <div *ngIf="showDownloadUploadOptionsSignal()" class="download-upload-options" (clickOutside)="clickOutsideDownloadUploadOptions()">
          <!-- <button mat-menu-item (click)="openExportFunctionalityDialog()" class="download-upload-options--option">
            <mat-icon class="download-upload-options--option-icon">download</mat-icon>
            <span>{{ 'COM.BUTTONS.EXPORT_REPORT' | translate }}</span>
          </button> -->
          <button mat-menu-item (click)="openBulkUploadFunctionalityDialog()" class="download-upload-options--option">
            <mat-icon class="download-upload-options--option-icon">upload</mat-icon>
            <span>{{ 'COM.BUTTONS.BULK_UPLOAD' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Chart container -->
  <div class="chart-wrapper">
    <!-- Loading indicator -->
    <div *ngIf="loadingSignal()" class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ 'COM.TABS.OPEN.CHART.LOADING_TEXT' | translate }}</p>
    </div>

    <ng-container *ngIf="!loadingSignal() && hasDataSignal()">
      <div class="dst-banner" role="status" aria-live="polite" *ngIf="dstStatusSignal().hasDSTTransition">
        <span class="dst-banner__icon" aria-hidden="true">ⓘ</span>

        <span class="dst-banner__text">
          <ng-container *ngIf="dstStatusSignal().type === 'fall_back'"
            >This date includes a Daylight Saving Time shift, resulting in an extra 02:00 hour in the selected time zone.</ng-container
          >
          <ng-container *ngIf="dstStatusSignal().type === 'spring_forward'"
            >This date includes a Daylight Saving Time change, which causes the 02:00 hour to be skipped in the selected time zone.</ng-container
          >
        </span>
      </div>

      <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions()" [callbackFunction]="chartCallback" class="chart-container">
      </highcharts-chart>
    </ng-container>

    <!-- No data message -->
    <div *ngIf="!hasDataSignal() && !loadingSignal()" class="no-data-container">
      <p>{{ 'COM.TABS.OPEN.CHART.NO_CHART_TEXT' | translate }}</p>
    </div>
  </div>
</div>
